import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EmailComponent } from "./email.component";

import { RouterModule, Routes } from "@angular/router";
import { DashboardModule } from "../dashboard.module";
import { TableModule } from "primeng/table";
import { TreeTableModule } from "primeng/treetable";
import { CardModule } from "primeng/card";
import { AvatarModule } from "primeng/avatar";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { EscapeHtmlPipe } from "../conversations/sanitizer.pipe";
import { ConversationsModule } from "../conversations/conversations.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { AutosizeModule } from "ngx-autosize";
import { ImapConfigComponent } from "./imap-config/imap-config.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

import { ChipModule } from "primeng/chip";

import { EmailContentComponent } from "./email-content/email-content.component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { ActiveClientsOnlyPipe } from "../main/common/active-clients-only.pipe";
import { EmailCardComponent } from "./email-card/email-card.component";
import { PaginatorModule } from "primeng/paginator";
import { CheckboxModule } from "primeng/checkbox";
import { EmailFormComponent } from "./email-form/email-form.component";

const routes: Routes = [{ path: "", component: EmailComponent }];

@NgModule({
  imports: [
    ActiveClientsOnlyPipe,

    ChipModule,
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    TreeTableModule,
    CardModule,
    AvatarModule,
    ProgressSpinnerModule,
    DialogModule,
    ButtonModule,
    ConversationsModule,
    TooltipModule,
    AutosizeModule,
    BsDropdownModule.forRoot(),
    TypeaheadModule.forRoot(),
    PaginatorModule,
    CheckboxModule,
    EmailComponent,
    ImapConfigComponent,
    EmailContentComponent,
    EmailCardComponent,
    EmailFormComponent,
  ],
  exports: [ActiveClientsOnlyPipe, EmailCardComponent],
  providers: [],
})
export class EmailModule {}
